import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zapier = defineConnector({
  identifier: "zapier",
  name: "Zapier",
  tagLine: "Workflow automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://api\\.zapier\\.com/.*|https://actions\\.zapier\\.com/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Zapier API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Zapier developer platform](https://developer.zapier.com/) and generate an API key for your integration.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.zapier.com/v2/zaps",
  },
});
